export default {
  plants: null,
  authenticated: false,
  loginErrors: [],
  registrationErrors: [],
  registered: false,
  loading: true
};
